module.exports = function getResource(label, vars = []) {
    let resources = {
        please: 'Please',
        signIn: 'sign in',
        review: 'to review this section.'
    };

    return resources[label];
};
